import { inject, Injectable } from "@angular/core";
import { DashboardShareCreateDto, DashboardShareListDto, DashboardSharesService } from "app/common/generated";
import { DialogService } from "app/common/services/dialog.service";
import { catchError, Observable, of } from "rxjs";
import { DashboardShareDialogComponent } from ".";

@Injectable({
    providedIn: "root",
})
export class DashboardShareAppService {
    private readonly apiService = inject(DashboardSharesService);
    private readonly dialogService = inject(DialogService);

    constructor() { }

    public getDashboardShares(dashboardId: string): Observable<DashboardShareListDto[]> {
        return this.apiService.getDashboardShares(dashboardId).pipe();
    }

    public deleteDashboardShare(shareId: string): Observable<void> {
        return this.apiService.removeDashboardShare(shareId).pipe();
    }

    public openShareDialog(dashboardId: string): Observable<DashboardShareCreateDto | null> {
        return this.dialogService.openDialog(DashboardShareDialogComponent, { dashboardId }, "md").pipe(
            catchError(() => {
                return of(null);
            })
        );
    }

    public createDashboardShare(payload: DashboardShareCreateDto): Observable<void> {
        return this.apiService.shareDashboard(payload).pipe();
    }

    public unshareDashboard(dashboardId: string): Observable<void> {
        return this.apiService.unshareDashboard(dashboardId).pipe();
    }
}